/**
 * A helper function that causes a compiler error if this function could be called.
 * Useful for ensuring union types are exhausted.
 */
export function assertNever(value: never): never {
  throw new Error(`Expected this branch to never be executed. Value: ${value}`);
}
